import { VButton, VTooltip, VTooltipContent, VTooltipTrigger } from '@vrzl/ui';
import { MessageSquarePlus } from 'lucide-react';
import { useState } from 'react';

import { FeedbackModal } from './feedbackModal';

/**
 * Vaste feedbackknop rechtsonder, op elke pagina binnen de app-layout.
 * Onder `sm` alleen het icoon; de toegankelijke naam is altijd "Feedback geven".
 */
export function FeedbackButton() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <VTooltip>
        <VTooltipTrigger asChild>
          <VButton
            variant="outline"
            icon={MessageSquarePlus}
            aria-label="Feedback geven"
            onClick={() => setIsOpen(true)}
            className="fixed right-6 bottom-6 z-50 rounded-full border-neutral-300 shadow-xl print:hidden focus-visible:ring-2 focus-visible:ring-neutral-500 focus-visible:ring-offset-2"
          >
            <span className="hidden sm:inline">Feedback</span>
          </VButton>
        </VTooltipTrigger>
        <VTooltipContent>Feedback geven</VTooltipContent>
      </VTooltip>

      <FeedbackModal open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
}
